const styleNameFor = str => str && str.replace(/\s+$/g,'').replace(/\s+/g, '-').toLowerCase();

export default styleNameFor;

